export type SgAdvisoryAction = AdvisoryResultFormLoadRequested;

export const advisoryResultFormLoadRequested = (newTabId: string, quoteId: string, basket: string[]) => ({
  type: 'ADVISORY_RESULT_FORM_LOAD_REQUESTED' as const,
  newTabId,
  quoteId,
  basket,
});

export type AdvisoryResultFormLoadRequested = ReturnType<typeof advisoryResultFormLoadRequested>;
